export default __webpack_public_path__ + "static/media/ChequePmtPrev.5104ebc5.jpeg";